import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfirmDialogHost } from "@/lib/confirm";
import { Layout } from "@/components/Layout";
import { Dashboard } from "@/pages/Dashboard";
import { CreateSeason } from "@/pages/CreateSeason";
import { SeasonDetail } from "@/pages/SeasonDetail";
import { SeasonHome } from "@/pages/SeasonHome";
import { Players } from "@/pages/Players";
import { Matches } from "@/pages/Matches";
import { Planning } from "@/pages/Planning";
import { Overview } from "@/pages/Overview";
import { PublicOverview } from "@/pages/PublicOverview";
import { Login } from "@/pages/Login";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Users } from "@/pages/Users";
import { GetStarted } from "@/pages/GetStarted";
import { MarketingHome } from "@/pages/MarketingHome";
import { AdminLogin } from "@/pages/AdminLogin";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { HomepageEditor } from "@/pages/HomepageEditor";
import { AuthEvents } from "@/pages/AuthEvents";
import { AdminHealth } from "@/pages/AdminHealth";
import { AdminDiscountCodes } from "@/pages/AdminDiscountCodes";
import { AdminPendingRegistrations } from "@/pages/AdminPendingRegistrations";
import { Expenses } from "@/pages/Expenses";
import { Activities } from "@/pages/Activities";
import { SubscriptionsPage } from "@/pages/SubscriptionsPage";
import { Register } from "@/pages/Register";
import { VerifyEmail } from "@/pages/VerifyEmail";
import { ImportExcel } from "@/pages/ImportExcel";
import { PwaInstallPrompt } from "@/components/PwaInstallPrompt";

function AppRouter() {

  return (
    <Routes>
      <Route path="/" element={<MarketingHome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/abonnementen" element={<SubscriptionsPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/share/:token" element={<PublicOverview />} />
      <Route path="/sportly-admin" element={<AdminLogin />} />
      <Route path="/sportly-admin/dashboard" element={<AdminDashboard />} />
      <Route path="/sportly-admin/homepage" element={<HomepageEditor />} />
      <Route path="/sportly-admin/auth-events" element={<AuthEvents />} />
      <Route path="/sportly-admin/health" element={<AdminHealth />} />
      <Route path="/sportly-admin/discount-codes" element={<AdminDiscountCodes />} />
      <Route path="/sportly-admin/pending" element={<AdminPendingRegistrations />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/import-excel" element={<ImportExcel />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/overview/:seasonPartId" element={<Overview />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/planning/:seasonPartId" element={<Planning />} />
        <Route path="/matches" element={<Matches />} />
        <Route path="/matches/:seasonPartId" element={<Matches />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/season" element={<SeasonHome />} />
        <Route path="/players" element={<Players />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/users" element={<Users />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create-season" element={<CreateSeason />} />
        <Route path="/season/:seasonId" element={<SeasonDetail />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <ConfirmDialogHost />
      <PwaInstallPrompt />
    </div>
  );
}

export default App;
